import { request } from "../network/request";
const db = "dn0";
/**
 * 获取问题列表
 */

export function getQuestionList(params) {
  return request({
    url: "pmp/question/questionList",
    method: "post",
    params: {
      ...params,
    },
  });
}

/**
 * 导出问题列表
 */
export function questionExport(params) {

  return request({
    url: "pmp/question/exportQuestion",
    method: "post",
    params,
  });
}



//根据数据类型获取字典列表
export function getDictData(dictType, type) {
  return request({
    url: "system/getDictData",
    method: "get",
    params: {
      dictType,
      type,
    },
  });
}


/**
 *  附件上传
 * @param {*} params 
 * @returns 
 */
export function submitUpload(params) {
  return request({
    url: "pmp/xqgl/upload",
    method: "post",
    data: params,
  });
}
/**
 * 新增问题保存
 * @param {*} params 
 * @returns 
 */
export function saveInsertQuestion(params) {
  return request({
    url: "pmp/xqgl/insertQuestion",
    method: "post",
    data: params,
  });
}

/**
 * 获取问题编辑详情
 * @param {*} params 
 * @returns 
 */
export function getQuestionDetail(params) {
  return request({
    url: "pmp/xqgl/getQuestion",
    method: "get",
    params,
  });
}

/**
 * 获取问题编辑--添加评论
 * @param {*} params 
 * @returns 
 */
export function saveComment(params) {
  return request({
    url: "pmp/xqgl/saveComment",
    method: "get",
    params,
  });
}

/**
 * 编辑问题保存
 * @param {*} params 
 * @returns 
 */
export function updateQuestion(params) {
  return request({
    url: "pmp/xqgl/updateQuestion",
    method: "post",
    data: params,
  });
}

/**
 * 上传文件
 * @param {*} params 
 * @returns 
 */
export function uploadFile(params) {
  return request({
    url: "pmp/xqgl/upload",
    method: "post",
    data: params,
  });
}
/**
 * 问题确认保存
 * @param {*} params 
 * @returns 
 */
export function confirmQuestion(params) {
  return request({
    url: "pmp/xqgl/confirmQuestion",
    method: "post",
    data: params,
  });
}
/**
 * 问题验证保存
 * @returns 
 */
export function checkQuestion(params) {
  return request({
    url: "pmp/xqgl/checkQuestion",
    method: "post",
    data: params,
  });
}
/**
 * 问题关闭
 * @param {*} params 
 * @returns 
 */
export function closeQuestion(params) {
  return request({
    url: "pmp/xqgl/closeQuestion",
    method: "post",
    data: params,
  });
}

/**
 * 问题查看
 * @param {*} params 
 * @returns 
 */
export function viewQuestion(params) {
  return request({
    url: "pmp/question/questionOne",
    method: "get",
    params,
  });
}
/**
 * 问题解决提交
 * @param {*} params 
 * @returns 
 */
export function solveQuestion(params) {
  return request({
    url: "pmp/xqgl/solveQuestion",
    method: "post",
    data: params,
  });
}
/**
 * 问题发起协作
 * @param {*} params 
 * @returns 
 */
export function addTask(params) {
  return request({
    url: "pmp/xqgl/addTask",
    method: "get",
    params,
  });
}
/**
 * 问题删除
 * @param {*} params 
 * @returns 
 */
export function deleteQuestion(params) {
  return request({
    url: "pmp/xqgl/deleteQuestion",
    method: "get",
    params,
  });
}
/**
 * 新增页面---获取默认指派人
 * @param {*} params 
 * @returns 
 */
export function getDesignee(params) {
  return request({
    url: "pmp/xqgl/getDesignee",
    method: "get",
    params,
  });
}

/**
 * 上线确认附件上传
 * @param {*} params 
 * @returns 
 */
export function uploadQrFile(params) {
  return request({
    url: "pmp/xqgl/insertQrFile",
    method: "post",
    data: params,
  });
}
/**
 * 上线确认
 * @param {*} params 
 * @returns 
 */
export function sxqrQuestion(params) {
  return request({
    url: "pmp/xqgl/sxqrQuestion",
    method: "post",
    data: params,
  });
}




export function updateReview(id, eventId, status, mc, bz) {
  return request({
    url: "pmp/xqgl/updateReview",
    method: "post",
    params: {
      db, id, eventId, status, mc, bz
    },
  });
}

export function startReview(id, reviewer, mc) {
  return request({
    url: "pmp/xqgl/startReview",
    method: "post",
    params: {
      db, id, reviewer, mc
    },
  });
}

export function getUserConfig() {
  return request({
    url: "pmp/navConfig/getUserConfig",
    method: "post",
  });
}
export function getConfigInfoWithYh() {
  return request({
    url: "pmp/navConfig/getConfigInfoWithYh",
    method: "post",
  });
}
export function updateConfig(params) {
  return request({
    url: "pmp/navConfig/updateConfig",
    method: "post",
    data: params,
  });
}
